import rejectNonOkResponse from '../rejectNonOkResponse.js';
import { productReviewFeedbackTemplateURL } from '../../../configuration/Configuration.js';

/**
 * Feedback value 1 = positive, 0 = negative
 *
 * @typedef {'1' | '0'} FeedbackValue
 */

/**
 * Send review feedback
 *
 * @param {string} reviewId
 * @param {number} feedback
 * @returns {{ reviewId; positiveFeedback: number; negativeFeedback; number }}
 * @example
 *   sendFeedback('123456', '1');
 */
export default async (reviewId, feedback) =>
  (
    await rejectNonOkResponse(
      fetch(productReviewFeedbackTemplateURL({ reviewId }), {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          negativeFeedback: feedback < 0 ? 1 : undefined,
          positiveFeedback: feedback > 0 ? 1 : undefined,
        }),
      })
    )
  ).json();
